import { useEffect, useState } from "react"

function getSavedValue(key, initialValue) {
    let savedValue = sessionStorage.getItem(key);
    if (savedValue) {
        try {
            savedValue = JSON.parse(savedValue);
        } catch (error) { savedValue = null; }
    }
    if (savedValue) return savedValue;
    if (initialValue instanceof Function) return initialValue();
    return initialValue;
}

export default function useSessionStorage(key, initialValue) {
    
    const [value, setValue] = useState(() => getSavedValue(key, initialValue));

    useEffect(() => {
        sessionStorage.setItem(key, JSON.stringify(value));
    }, [value]);

    return [ value, setValue ];
}
